import {useState} from 'react';

// Hook to copy items with cross browser support
export default function useClipboard({
  clipboard = window.navigator.clipboard,
} = {}) {
  const [isCopied, setIsCopied] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  // Navigator.clipboard.writeText() is an async API that is a replacement for execCommand('copy')
  // Browser support is currently limited to Chrominum based browsers
  // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
  // https://www.w3.org/TR/clipboard-apis/#async-clipboard-api
  function copy(content) {
    if (!!clipboard && !!content) {
      clipboard
        .writeText(content)
        .then(() => {
          setIsCopied(true);
        })
        .catch((error) => {
          setIsCopied(false);
          setErrorMessage(error);
        });
    } else {
      // Fallback for browsers that do not support Navigator.clipboard.writeText()
      const textarea = document.createElement('textarea');
      // Add styles to visually hide textarea
      textarea.setAttribute(
        'style',
        'position: absolute; left: -100vw; top: auto; width: 1px; height: 1px; overflow: hidden; transform: translateZ(0);'
      );
      textarea.textContent = content;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        document.body.removeChild(textarea);
        setIsCopied(true);
      } catch (error) {
        setIsCopied(false);
        setErrorMessage(error);
      }
    }
  }

  function reset() {
    setIsCopied(false);
  }

  return {copy, isCopied, errorMessage, reset};
}
